/* eslint-disable multiline-ternary */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import { useSubscription } from '@apollo/client'
import { Badge, Button, Col, Row } from 'react-bootstrap'

import styles from './style.module.scss'
import teamPlaceholder from '@assets/images/placeholder/team-placeholder.jpg'
import { CaretDownIcon } from '@shared/components/ctIcons'
import { GET_LIVE_AUCTION_SUMMARY } from '@graphql/ipl-auction/ipl-auction-live.suscription'
import { getImgURL, numDifferentiation } from '@shared/utils'

const Ads = dynamic(() => import('@shared/components/ads'))
const IplRetentions = dynamic(() => import('@shared/components/widgets/iplRetentions'))
const AuctionSummery = dynamic(() => import('../auctionSummary'))
const PlayerImg = dynamic(() => import('@shared/components/playerImg'))
const MyImage = dynamic(() => import('@shared/components/myImage'))
const BiddingList = dynamic(() => import('@shared/components/auction/biddingList'))
const AuctionPlayer = dynamic(() => import('@shared/components/auction/auctionPlayer'))

const LiveTab = ({ className, auctionId, auctionData, category, overview }) => {
  const [isOpen, setIsOpen] = useState(true)
  const [data, setData] = useState(auctionData?.getLiveAuctionSummary?.oData || {})
  const teamUrl = data?.oCurrentPlayer?.oPrimaryTeam?.oImg?.sUrl || data?.oCurrentPlayer?.oCountry?.oImg?.sUrl

  useSubscription(GET_LIVE_AUCTION_SUMMARY, {
    variables: { input: { iAuctionSeriesId: auctionId } },
    skip: typeof window === 'undefined',
    onSubscriptionData: ({ subscriptionData }) => {
      setData(subscriptionData?.data?.getLiveAuctionSummary)
    }
  })

  if (category?.data?.oAuctionSeries?.eAuctionStatus === 'l') {
    return (
      <Row>
        {data?.oCurrentPlayer && (
          <Col lg={6}>
            <div className={`${className || ''}`}>
              <h6>{data?.eBidOperation === 'sp' ? 'Next player coming...' : data?.oCurrentPlayer ? 'Live Bidding on' : 'Auction resuming soon...'}</h6>
              {data?.oCurrentPlayer && (
                <div className={`${styles.card} light-bg text-center br-lg position-relative ${isOpen ? 'overflow-hidden' : ''}`}>
                  <div className={`${styles.inner}`}>
                    {data?.oCurrentPlayer?.eAuctionStatus === 's' && (
                      <Badge bg="danger" className={`${styles.badge} ${styles.sold} position-absolute top-0 end-0 m-2 m-md-3`}>
                        Sold
                      </Badge>
                    )}
                    {data?.oCurrentPlayer?.eAuctionStatus === 'us' && (
                      <Badge bg="danger" className={`${styles.badge} ${styles.unsold} position-absolute top-0 end-0 m-2 m-md-3`}>
                        UnSOLD
                      </Badge>
                    )}
                    {data?.oCurrentPlayer?.eAuctionStatus === 'r' && (
                      <Badge bg="danger" className={`${styles.badge} ${styles.retained} position-absolute top-0 end-0 m-2 m-md-3`}>
                        Retained
                      </Badge>
                    )}
                    {data?.oCurrentPlayer?.eAuctionStatus === 'rtm' && (
                      <Badge bg="danger" className={`${styles.badge} ${styles.retained} position-absolute top-0 end-0 m-2 m-md-3`}>
                        RTM
                      </Badge>
                    )}
                    {data?.oCurrentPlayer?.eAuctionStatus === 't' && (
                      <Badge bg="danger" className={`${styles.badge} ${styles.retained} position-absolute top-0 end-0 m-2 m-md-3`}>
                        Transferred
                      </Badge>
                    )}
                    {data?.oCurrentPlayer?.eAuctionStatus === 'b' && (
                      <Badge bg="danger" className={`${styles.badge} ${styles.retained} position-absolute top-0 end-0 m-2 m-md-3`}>
                        Bidding
                      </Badge>
                    )}
                    {data?.oCurrentPlayer?.eAuctionStatus === 'd' && (
                      <Badge bg="danger" className={`${styles.badge} position-absolute top-0 end-0 m-2 m-md-3`}>
                        Live
                      </Badge>
                    )}
                    <div className={`${styles.playerImg} mx-auto rounded-circle overflow-hidden`}>
                      <PlayerImg head={data?.oCurrentPlayer?.oPlayer?.oImg} jersey={data?.oCurrentPlayer?.oPrimaryTeam?.oJersey} enableBg />
                    </div>
                    <h5 className="mb-1 mb-md-2">{data?.oCurrentPlayer?.oPlayer?.sFullName}</h5>
                    <div className={`${styles.info} d-flex align-items-center justify-content-center mb-3`}>
                      <div className="d-flex align-items-center">
                        <span className={`${styles.flag} me-2 rounded-circle overflow-hidden flex-shrink-0`}>
                          <MyImage
                            src={teamUrl ? getImgURL(teamUrl) : teamPlaceholder}
                            width="48"
                            height="48"
                            alt={
                              data?.oCurrentPlayer?.oPrimaryTeam?.oImg?.sText ||
                              data?.oCurrentPlayer?.oCountry?.oImg?.sText ||
                              data?.oCurrentPlayer?.oPrimaryTeam?.sTitle ||
                              data?.oCurrentPlayer?.oCountry?.sTitle
                            }
                          />
                        </span>
                        {data?.oCurrentPlayer?.oPrimaryTeam?.sTitle || data?.oCurrentPlayer?.oCountry?.sTitle}
                      </div>
                      <span className="text-capitalize">{data?.oCurrentPlayer?.sPlayingRole}</span>
                    </div>
                    <div className="d-flex align-items-center text-center gap-2 gap-xl-3 mb-3">
                      <div className={`${styles.price} br-sm flex-grow-1`}>
                        <p className="text-small mb-1 gap-2 d-flex align-items-center justify-content-center">Base Price</p>
                        <h5 className="mb-0">{numDifferentiation(data?.oCurrentPlayer?.nBasePrice)}</h5>
                      </div>
                      <div className={`${styles.price} ${styles.active} br-sm flex-grow-1`}>
                        <p className="text-small mb-1 gap-2 d-flex align-items-center justify-content-center">
                          <span className={`${styles.dot} me-1`}></span> Live Price
                        </p>
                        <h5 className="mb-0">
                          {numDifferentiation(data?.oCurrentPlayer?.aBid[0]?.nBidPrice || data?.oCurrentPlayer?.nBasePrice)}
                        </h5>
                      </div>
                    </div>
                  </div>
                  <Button
                    variant="link"
                    className={`${styles.toggleBtn} small-text btn-link w-100 rounded-0 position-relative`}
                    onClick={() => setIsOpen(!isOpen)}
                  >
                    {data?.oCurrentPlayer?.aBid[0]?.oTeam?.sTitle
                      ? `Last Bid by ${data?.oCurrentPlayer?.aBid[0]?.oTeam?.sTitle}`
                      : 'Bid Awaits...'}
                    <span
                      className={`${styles.arrow} ${
                        isOpen ? styles.active : ''
                      } d-lg-none c-transition position-absolute top-50 end-0 me-2`}
                    >
                      <CaretDownIcon />
                    </span>
                  </Button>
                  <BiddingList
                    isOpen={isOpen}
                    bidList={data?.oCurrentPlayer?.aBid}
                    basePrice={numDifferentiation(data?.oCurrentPlayer?.nBasePrice)}
                  />
                </div>
              )}
            </div>
          </Col>
        )}
        {data?.aRecentPickPlayers?.length > 0 && (
          <Col lg={6} className="mb-3">
            <h6>Recent Picks</h6>
            {data?.aRecentPickPlayers?.map((player, index) => (
              <AuctionPlayer key={index} player={player} slug={category?.data?.sSlug} />
            ))}
          </Col>
        )}
      </Row>
    )
  } else if (category?.data?.oAuctionSeries?.eAuctionStatus === 'c') {
    return (
      <>
        <AuctionSummery overview={overview} />
        {category?.topsPicks?.length > 0 && (
          <Row className="gx-3">
            <Col xs={12}>
              <h6 className={`${styles.secTitle} line-title mb-3 mb-md-3 text-uppercase overflow-hidden`}>
                <span className="rounded-pill mx-1 px-2 px-xl-3 position-relative d-inline-block">Top Picks</span>
              </h6>
            </Col>
            {category?.topsPicks?.map((player, index) => (
              <Col key={index} lg={6} className="mb-3">
                <AuctionPlayer player={player} slug={category?.data?.sSlug} />
              </Col>
            ))}
          </Row>
        )}
        <Ads
          id={'div-topsPicks-ad-mob-23148549803-1732886876-0'}
          adIdDesktop="Crictracker_New_Mobile_SP_MID_320x100"
          dimensionDesktop={[320, 100]}
          slotId="23148549803"
          hideOn="desktop"
          className={'text-center mb-3'}
        />
        {overview?.aTopBatterData?.length > 0 && (
          <Row className="gx-3">
            <Col xs={12}>
              <h6 className={`${styles.secTitle} line-title mb-3 mb-md-3 text-uppercase overflow-hidden`}>
                <span className="rounded-pill mx-1 px-2 px-xl-3 position-relative d-inline-block">Top Batters</span>
              </h6>
            </Col>
            {overview?.aTopBatterData?.map((player, index) => {
              return (
                <Col key={player?._id + index} lg={6} className="mb-3">
                  <AuctionPlayer player={player} slug={category?.data?.sSlug} />
                </Col>
              )
            })}
          </Row>
        )}
        <Ads
          id={'div-aTopBatterData-ad-mob-23148549803-1732886876-0'}
          adIdDesktop="Crictracker_New_Mobile_SP_MID_320x100"
          dimensionDesktop={[320, 100]}
          slotId="23148549803"
          hideOn="desktop"
          className={'text-center mb-3'}
        />
        {overview?.aTopBowlerData?.length > 0 && (
          <Row className="gx-3">
            <Col xs={12}>
              <h6 className={`${styles.secTitle} line-title mb-3 mb-md-3 text-uppercase overflow-hidden`}>
                <span className="rounded-pill mx-1 px-2 px-xl-3 position-relative d-inline-block">Top Bowlers</span>
              </h6>
            </Col>
            {overview?.aTopBowlerData?.map((player, index) => {
              return (
                <Col key={player?._id + index} lg={6} className="mb-3">
                  <AuctionPlayer player={player} slug={category?.data?.sSlug} />
                </Col>
              )
            })}
          </Row>
        )}
        <Ads
          id={'div-aTopBowlerData-ad-mob-23148549803-1732886876-0'}
          adIdDesktop="Crictracker_New_Mobile_SP_MID_320x100"
          dimensionDesktop={[320, 100]}
          slotId="23148549803"
          hideOn="desktop"
          className={'text-center mb-3'}
        />
        {overview?.aTopAllRounderData?.length > 0 && (
          <Row className="gx-3">
            <Col xs={12}>
              <h6 className={`${styles.secTitle} line-title mb-3 mb-md-3 text-uppercase overflow-hidden`}>
                <span className="rounded-pill mx-1 px-2 px-xl-3 position-relative d-inline-block">Top All-Rounders</span>
              </h6>
            </Col>
            {overview?.aTopAllRounderData?.map((player, index) => {
              return (
                <Col key={player?._id + index} lg={6} className="mb-3">
                  <AuctionPlayer player={player} slug={category?.data?.sSlug} />
                </Col>
              )
            })}
          </Row>
        )}
        <Ads
          id={'div-aTopAllRounderData-ad-mob-23148549803-1732886876-0'}
          adIdDesktop="Crictracker_New_Mobile_SP_MID_320x100"
          dimensionDesktop={[320, 100]}
          slotId="23148549803"
          hideOn="desktop"
          className={'text-center'}
        />
      </>
    )
  } else {
    return (
      <div>
        <h6>Auction starting soon...</h6>
        <IplRetentions />
      </div>
    )
  }
}
LiveTab.propTypes = {
  className: PropTypes.string,
  auctionId: PropTypes.string,
  auctionData: PropTypes.object,
  category: PropTypes.object,
  overview: PropTypes.object
}

export default LiveTab
